/** ไม้เท้าคลื่น (lane C4 skeleton): azure + steel, motif drops. Built from swordKit via families/handArtGen.ts; polish later. */
import { makeHandArt } from '../families/handArtGen';

export const TIDESTAFF_FX: ReturnType<typeof makeHandArt> = makeHandArt('tide-staff', { a: 'azure', b: 'steel', motif: 'drops' }, [
  ['tt-wave', 'palm', 2.9],
  ['tt-ankle', 'claw'],
  ['tt-whirl', 'ring', 3],
  ['tt-vault', 'palm', 5],
  ['tt-pin', 'grab'],
  ['tt-ripple', 'ring', 5],
  ['tt-ward', 'buff'],
  ['tt-tide', 'power', 4],
], 'staff');
